import React, { useState } from "react";
import BaseMap from "./BaseMap";
import GeoJSONMap from "pages/Map/components/GeoJSONMap";
import useProperties from "hooks/useProperties";
import RemoveWarningDialog from "components/Dialog/RemoveWarningDialog";

const DashboardMap = () => {
  const [selectedLocations, setSelectedLocations] = useState([]);
  const { getDashboardMarketStatistics } = useProperties();
  const [openWarningModal, setOpenWarningModal] = useState(false);

  const toggleLocationSelection = (prevSelectedLocations, location) => {
    const locationId = location.properties.FID_1;
    const locationExists = prevSelectedLocations.some(
      (loc) => loc.properties.FID_1 === locationId
    );

    return locationExists
      ? prevSelectedLocations.filter(
          (loc) => loc.properties.FID_1 !== locationId
        )
      : [...prevSelectedLocations, location];
  };

  const handleMapLocationSelect = (location) => {
    setSelectedLocations((prevSelectedLocations) => {
      const updatedSelectedLocations = toggleLocationSelection(
        prevSelectedLocations,
        location
      );

      if (updatedSelectedLocations.length > 5) {
        setOpenWarningModal(true);
        return prevSelectedLocations;
      }
      // Make search
      handleSearch(updatedSelectedLocations);

      return updatedSelectedLocations;
    });
  };

  // Handle search on location select from map
  const handleSearch = async (locations) => {
    const locationIds = locations.map(
      (location) => location?.properties?.FID_1
    );

    try {
      const filters = {
        locationIds,
      };

      const res = await getDashboardMarketStatistics(filters);

      return res;
    } catch (error) {
      console.log("Search property error: ", error);
    }
  };

  return (
    <div className="w-full xl:w-[36.2%] rounded-[16px] h-[156px] sm:h-[200px] md:h-[300px] lg:h-[594px]">
      <BaseMap
        mapStyle={{ height: "100%", zIndex: 1, borderRadius: 16 }}
        visibleZoom={false}
        scrollWheelZoom={false}
      >
        <GeoJSONMap
          selectedLocations={selectedLocations}
          onLocationSelect={handleMapLocationSelect}
        />
      </BaseMap>

      <RemoveWarningDialog
        isOpen={openWarningModal}
        isClose={() => setOpenWarningModal(false)}
        warningText={"Puoi confrontare massimo 5 zone"}
        onClick={() => setOpenWarningModal(false)}
        buttonText="Chiudi"
      />
    </div>
  );
};

export default DashboardMap;
